import { formatCount } from '../../../../../utils/sms';
import { formatPercent } from './chart-theme';

/** One category of a recipient breakdown (gender, age group). */
export interface DistributionRow {
  label: string;
  count: number;
  /** Share of all recipients, 0–100. */
  share: number;
  shareLabel: string;
  countLabel: string;
}

/** Counts → rows with their share of the total (or of their sum when no total is given). */
export function toDistribution(
  categories: { label: string; count: number | null | undefined }[],
  total: number | null | undefined
): DistributionRow[] {
  const counts = categories.map((category) => Math.max(0, Number(category.count) || 0));
  const sum = counts.reduce((all, count) => all + count, 0);
  const base = Number(total) > 0 ? Number(total) : sum;
  return categories.map((category, index) => {
    const count = counts[index];
    const share = base > 0 ? (count / base) * 100 : 0;
    return {
      label: category.label,
      count,
      share,
      shareLabel: formatPercent(share),
      countLabel: formatCount(count),
    };
  });
}
